import { Button, Typography } from '@mui/material'
import React from 'react'
import MainHeroLayout from './MainHeroLayout'
import  Logo  from "../../Media/LogoV1.png";
import  Cuaderno  from "../../Media/Cuaderno.jpg";
import { auth } from '../../firebase/firebase';
import { useState } from 'react';
import { useEffect } from 'react';

const backgroundImage =
  'https://images.unsplash.com/photo-1534854638093-bada1813ca19?auto=format&fit=crop&w=1400';

const MainHero = () => {
    
    const [usuarioLogeado, setUsuarioLogeado] = useState(null);

    const user = auth.currentUser;
    
    useEffect(() => {
      verificarUsuario();
    }, [])
    
    const verificarUsuario = () =>{
        if(user === null){
            setUsuarioLogeado(false);
        }
        if(user !== null){
            if(user.email){
                setUsuarioLogeado(true);
            }
        }
    }

    return (
        <MainHeroLayout
          sxBackground={{
            backgroundImage: `url(${Cuaderno})`,
            backgroundColor: '#7fc7d9', // Average color of the background image.
            backgroundPosition: 'center',
          }}
        >
            {/* Increase the network loading priority of the background image. */}
            <img
                style={{ display: 'none' }}
                src={backgroundImage}
                alt="increase priority"
            />
            <img
                src={Logo}
                alt="increase priority"
                style={{
                    paddingTop: '30px',
                    width: '600px',
                    alignContent: 'center',
                    textAlign: 'center',
                    alignItems: 'center'
                }}
            />
            {/* <Typography 
                color="black" 
                align="center" 
                variant="h1" 
                marked="center"
                fontFamily='Bad Script'
            >
                Gemm
            </Typography>
            <Typography 
                color="white" 
                align="center" 
                variant="h6" 
                marked="center"
                fontFamily='Noto Sans Warang Citi'
                sx={{fontWeight: 'bold'}}
            >
                GESTOR Y EDITOR DE MAPAS MENTALES
            </Typography> */}
            <Typography
                color="inherit"
                align="center"
                variant="h6"
                sx={{ mb: 4, mt: { sx: 4, sm: 10 } }}
            >
                ¡Regístrate y organiza tus ideas en Mapas Mentales!
            </Typography>
            {
                usuarioLogeado ?
                (
                    <>
                        <Button
                            color="primary"
                            variant="contained"
                            size="large"
                            component="a"
                            href="/lienzo"
                            sx={{ minWidth: 100 }}
                        >
                            ¡Empezar!
                        </Button>
                        <Typography variant="body2" color="inherit" sx={{ mt: 2, mb:3 }}>
                            ¡Comienza a crear tus diagramas!
                        </Typography>
                        <Button
                            color="primary"
                            variant="contained"
                            size="large"
                            component="a"
                            href="https://forms.gle/9Z2M8Vt9gXyHpAXz7"
                            target="_blank"
                            sx={{ minWidth: 100 }}
                        >
                            Encuesta
                        </Button>
                        <Typography variant="body2" color="inherit" sx={{ mt: 2, mb:3 }}>
                            Completa esta encuesta despues de probar el sistema.
                        </Typography>
                    </>
                    
                )
                :
                (
                    <>
                        <Button
                            color="primary"
                            variant="contained"
                            size="large"
                            component="a"
                            href="/register"
                            sx={{ minWidth: 100, mb: 2  }}
                        >
                            Registrate
                        </Button>
                        <Typography variant="body2" color="inherit" sx={{ }}>
                            O puedes
                        </Typography>

                        <Button
                            color="primary"
                            variant="contained"
                            size="large"
                            component="a"
                            href="/lienzo"
                            sx={{ minWidth: 100, mt: 2 }}
                            >
                            ¡Empezar ya!
                        </Button>

                        <Typography 
                            variant="body2" 
                            color="inherit" 
                            sx={{
                                mt: 2,
                                mb: 2
                            }}
                        >
                            Al no estar registrado no podras guardar tus diagramas en la nube.
                        </Typography>

                        
                    </>
                    
                )
            }
            
            {/* <Typography variant="body2" color="inherit" sx={{ mt: 2 }}>
                Ordena tus ideas desde ya!
            </Typography> */}
        </MainHeroLayout>
    );
}

export default MainHero